import React from "react";
import { useFormContext } from "react-hook-form";

import { AutoFormFieldProps } from "@autoform/react";

import { AreaPicker } from "@/components/fields/area-picker";

/** `customData` of an `area` field. */
export type IAreaFieldCustomData = {
  /** Offer the field's own `area` text (the Places string on a new venue) as the picker's hint. */
  hintFromText?: boolean;
};

/**
 * A venue's area, picked from its city's official areas. The form carries two keys: `areaId`, which the picker writes
 * (the server then sets the `area` text), and `area`, the text, which only the free-text fallback of a city with no
 * areas writes. A venue saved without a pick sends neither, so an untouched area is never cleared.
 */
export const AreaField: React.FC<AutoFormFieldProps> = ({ field }) => {
  const form = useFormContext();
  const geodata = form.watch("geodata") as
    | { name?: string; countryCode?: string }
    | undefined;
  const areaId = form.watch("areaId") as string | null | undefined;
  const area = form.watch("area") as string | null | undefined;
  const customData = field.fieldConfig?.customData as
    | IAreaFieldCustomData
    | undefined;

  return (
    <AreaPicker
      city={geodata?.name}
      countryCode={geodata?.countryCode}
      value={areaId}
      currentName={area}
      hint={customData?.hintFromText ? (area ?? undefined) : undefined}
      textValue={area}
      onChange={(next) => form.setValue("areaId", next, { shouldDirty: true })}
      onTextChange={(text) =>
        form.setValue("area", text, { shouldDirty: true })
      }
    />
  );
};

export default AreaField;
